import {
  PhoneXMarkIcon,
  UserIcon,
  ClockIcon,
  CurrencyDollarIcon,
  PhoneIcon
} from '@heroicons/react/24/outline';

// Stats card icons mapping
export const statsIcons = {
  callsDropped: PhoneXMarkIcon,
  callsEnded: UserIcon,
  averageDuration: ClockIcon,
  averageCost: CurrencyDollarIcon,
  totalCalls: PhoneIcon
} as const;

export type StatsIconKey = keyof typeof statsIcons;